<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '120px'">
          <el-form-item label="用户id" prop="customerId">
          <el-input v-model="dataForm.customerId" placeholder="用户id"></el-input>
      </el-form-item>
          <el-form-item label="公司ID" prop="companyId">
          <el-input v-model="dataForm.companyId" placeholder="公司ID"></el-input>
      </el-form-item>
      <el-form-item label="回访类型" prop="callType">
           <el-select v-model="dataForm.callType" filterable clearable placeholder="请选择">
	          <el-option
	                  v-for="item in callbackList"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
          </el-select>
      </el-form-item>
          <el-form-item label="推送内容" prop="content">
          <el-input v-model="dataForm.content" placeholder="推送内容"></el-input>
      </el-form-item>
          <el-form-item label="备注" prop="remark">
          <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
      </el-form-item>
      
          <el-form-item label="推送返回状态码" prop="pushCode">
          <el-input v-model="dataForm.pushCode" placeholder="推送返回状态码"></el-input>
      </el-form-item>
          <el-form-item label="推送返回信息" prop="pushMsg">
          <el-input v-model="dataForm.pushMsg" placeholder="推送返回信息"></el-input>
      </el-form-item>
          
      <el-form-item label="状态" prop="status">
        <el-select v-model="dataForm.status" filterable clearable placeholder="请选择">
	          <el-option
	                  v-for="item in statusList"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="类型" prop="type">
         <el-select v-model="dataForm.type" filterable clearable placeholder="请选择">
	          <el-option
	                  v-for="item in typeList"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="是否已推送" prop="isPush">
        <el-select v-model="dataForm.isPush" filterable clearable placeholder="请选择">
	          <el-option
	                  v-for="item in isPushList"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="渠道ID" prop="channelId">
          <el-input v-model="dataForm.channelId" placeholder="渠道ID"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        customerId: '',
        companyId: '',
        callType: '',
        content: '',
        remark: '',
        isPush: '',
        pushCode: '',
        pushMsg: '',
        pushDate: '',
        creator: '',
        createDate: '',
        updateBy: '',
        updateTime: '',
        deleteTime: '',
        status: '',
        type: '',
        channelId: ''
      },
      isPushList:[
        {value: 1, label: '是'},
        {value: 0, label: '否'}
      ],
      statusList:[
        {value: 1, label: '有效'},
        {value: 0, label: '无效'}
      ],
      typeList:[
        {value: 0, label: '未回访'},
        {value: 1, label: '有效'},
        {value: 2, label: '无效'}
      ],
      callbackList:[
        {value: '0', label: '(0星)无建联'},
        {value: '1', label: '(1星)已建联，资质差，三无人员'},
        {value: '2', label: '(2星)有需求，无抵押物，需要养护'},
        {value: '3', label: '(3星)有需求，有可贷点，能进店客户'},
        {value: '4', label: '(4星)有需求，有抵押物，有公积金，能签约客户'},
        {value: '5', label: '(5星)已签约'}
      ],
    }
  },
  computed: {
    dataRule () {
      return {
        customerId: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        companyId: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        callType: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        content: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        remark: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        isPush: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pushCode: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pushMsg: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pushDate: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        type: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        channelId: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/crmcallback/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/crmcallback/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
